import React, { useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { IClient } from "../../interfaces/client";
import StyledLabel from "../Label/StyledLabel";
import { Button } from "reactstrap";
import { useClient } from "../../hooks/useClient";
import { NivelRisco } from "../../interfaces/product";

interface AddClientProps {
  Client?: IClient;
}

export const FormClient: React.FC<AddClientProps> = ({ Client }) => {
  const { handleSave, isLoading, isSaving } = useClient();

  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<IClient>({
    defaultValues: {
      ...Client,
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "products",
  });

  const onSubmit = (data: IClient) => {
    handleSave(data, !!Client, Client?.id);
  };

  const getRiscoLabel = (value: NivelRisco) => {
    switch (value) {
      case NivelRisco.AltissimoRisco:
        return "Altíssimo Risco";
      case NivelRisco.AltoRisco:
        return "Alto Risco";
      case NivelRisco.MedioRisco:
        return "Médio Risco";
      case NivelRisco.BaixoRisco:
        return "Baixo Risco";
      case NivelRisco.BaixissimoRisco:
        return "Baixíssimo Risco";
      default:
        return "Desconhecido";
    }
  };

  useEffect(() => {
    if (Client) {
      setValue("corporateName", Client.corporateName);
      setValue("cnpj", Client.cnpj);
      setValue("telephone", Client.telephone);
      setValue("zipCode", Client.zipCode);
      setValue("street", Client.street);
      setValue("number", Client.number);
      setValue("email", Client.email);
      setValue("urlWeebHook", Client.urlWeebHook);

      remove();
      if (Client.products && Client.products.length > 0) {
        Client.products.forEach((vp) => {
          append({
            description: vp.description,
            id: vp.id,
            idClient: vp.idClient,
            tagBiometria: vp.tagBiometria,
            weightLinkCPFEaddress: vp.weightLinkCPFEaddress,
            weightLinkCPFTelephone: vp.weightLinkCPFTelephone,
            weightLinkCPFEmail: vp.weightLinkCPFEmail,
            weightLinkEmailAddress: vp.weightLinkEmailAddress,
            weightLinkEmailTelephone: vp.weightLinkEmailTelephone,
            weightLinkTelephoneAddress: vp.weightLinkTelephoneAddress,
            riskLevelParameter: vp.riskLevelParameter,
            verifyAllPartners: vp.verifyAllPartners,
          });
        });
      }
    }
  }, [Client]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-md-6 mb-3">
          <StyledLabel>Nome Fantasia:*</StyledLabel>
          <input
            className="form-control"
            type="text"
            placeholder="Nome Fantasia"
            {...register("corporateName", {
              required: "Este campo é obrigatório.",
            })}
            style={{ borderRadius: "15px", padding: "10px" }}
          />
          {errors.corporateName && (
            <div className="invalid-feedback d-block">
              {errors.corporateName.message}
            </div>
          )}
        </div>

        <div className="col-md-6 mb-3">
          <StyledLabel>CNPJ:</StyledLabel>
          <input
            className="form-control"
            type="text"
            placeholder="CNPJ"
            {...register("cnpj")}
            style={{ borderRadius: "15px", padding: "10px" }}
          />
        </div>

        <div className="col-md-4 mb-3">
          <StyledLabel>Telefone:</StyledLabel>
          <input
            className="form-control"
            type="text"
            placeholder="Telefone"
            {...register("telephone")}
            style={{ borderRadius: "15px", padding: "10px" }}
          />
        </div>

        <div className="col-md-4 mb-3">
          <StyledLabel>CEP:</StyledLabel>
          <input
            className="form-control"
            type="text"
            placeholder="CEP"
            {...register("zipCode")}
            style={{ borderRadius: "15px", padding: "10px" }}
          />
        </div>

        <div className="col-md-4 mb-3">
          <StyledLabel>Rua:</StyledLabel>
          <input
            className="form-control"
            type="text"
            placeholder="Rua"
            {...register("street")}
            style={{ borderRadius: "15px", padding: "10px" }}
          />
        </div>

        <div className="col-md-2 mb-3">
          <StyledLabel>Número:</StyledLabel>
          <input
            className="form-control"
            type="number"
            placeholder="Número"
            {...register("number")}
            style={{ borderRadius: "15px", padding: "10px" }}
          />
        </div>

        <div className="col-md-5 mb-3">
          <StyledLabel>E-mail:*</StyledLabel>
          <input
            className="form-control"
            type="text"
            placeholder="E-mail"
            {...register("email", {
              required: "Este campo é obrigatório.",
            })}
            style={{ borderRadius: "15px", padding: "10px" }}
          />
          {errors.email && (
            <div className="invalid-feedback d-block">
              {errors.email.message}
            </div>
          )}
        </div>

        <div className="col-md-5 mb-3">
          <StyledLabel>Senha Adm:*</StyledLabel>
          <input
            className="form-control"
            type="text"
            placeholder="Senha Adm"
            {...register("password", {
              required: "Este campo é obrigatório.",
            })}
            style={{ borderRadius: "15px", padding: "10px" }}
          />
          {errors.password && (
            <div className="invalid-feedback d-block">
              {errors.password.message}
            </div>
          )}
        </div>

        <div className="col-md-5 mb-3">
          <StyledLabel>Webhook URL:</StyledLabel>
          <input
            className="form-control"
            type="text"
            placeholder="Webhook URL"
            {...register("urlWeebHook")}
            style={{ borderRadius: "15px", padding: "10px" }}
          />
        </div>
      </div>

      <hr />
      <h4>Produtos do Cliente</h4>

      {fields.map((field, index) => (
        <div
          key={field.id}
          className="p-3 mb-4 border rounded"
          style={{ backgroundColor: "#f9f9f9" }}
        >
          <div className="row">
            <div className="col-md-12 mb-3">
              <StyledLabel>Descrição:*</StyledLabel>
              <input
                className={`form-control ${
                  errors.products?.[index]?.description ? "is-invalid" : ""
                }`}
                placeholder="Descrição"
                style={{ borderRadius: "15px", padding: "10px" }}
                {...register(`products.${index}.description` as const, {
                  required: "A descrição é obrigatória.",
                })}
              />
              {errors.products?.[index]?.description && (
                <div className="invalid-feedback d-block">
                  {errors.products[index]?.description?.message}
                </div>
              )}
            </div>

            {/* <div className="col-md-4 mb-3">
              <StyledLabel>Peso CPF + Email:</StyledLabel>
              <input
                className="form-control"
                type="number"
                step="0.01"
                placeholder="Peso CPF + Email"
                style={{ borderRadius: "15px", padding: "10px" }}
                {...register(`products.${index}.weightLinkCPFEmail` as const, {
                  valueAsNumber: true,
                })}
              />
            </div> */}

            {/* <div className="col-md-4 mb-3">
              <StyledLabel>Peso CPF + Telefone:</StyledLabel>
              <input
                className="form-control"
                type="number"
                step="0.01"
                placeholder="Peso CPF + Telefone"
                style={{ borderRadius: "15px", padding: "10px" }}
                {...register(
                  `products.${index}.weightLinkCPFTelephone` as const,
                  { valueAsNumber: true }
                )}
              />
            </div> */}

            {/* <div className="col-md-4 mb-3">
              <StyledLabel>Peso CPF + Endereço:</StyledLabel>
              <input
                className="form-control"
                type="number"
                step="0.01"
                placeholder="Peso CPF + Endereço"
                style={{ borderRadius: "15px", padding: "10px" }}
                {...register(
                  `products.${index}.weightLinkCPFEaddress` as const,
                  { valueAsNumber: true }
                )}
              />
            </div> */}

            {/* <div className="col-md-4 mb-3">
              <StyledLabel>Peso Email + Telefone:</StyledLabel>
              <input
                className="form-control"
                type="number"
                step="0.01"
                placeholder="Peso Email + Telefone"
                style={{ borderRadius: "15px", padding: "10px" }}
                {...register(
                  `products.${index}.weightLinkEmailTelephone` as const,
                  { valueAsNumber: true }
                )}
              />
            </div> */}

            {/* <div className="col-md-4 mb-3">
              <StyledLabel>Peso Email + Endereço:</StyledLabel>
              <input
                className="form-control"
                type="number"
                step="0.01"
                placeholder="Peso Email + Endereço"
                style={{ borderRadius: "15px", padding: "10px" }}
                {...register(
                  `products.${index}.weightLinkEmailAddress` as const,
                  { valueAsNumber: true }
                )}
              />
            </div> */}

            {/* <div className="col-md-4 mb-3">
              <StyledLabel>Peso Telefone + Endereço:</StyledLabel>
              <input
                className="form-control"
                type="number"
                step="0.01"
                placeholder="Peso Telefone + Endereço"
                style={{ borderRadius: "15px", padding: "10px" }}
                {...register(
                  `products.${index}.weightLinkTelephoneAddress` as const,
                  { valueAsNumber: true }
                )}
              />
            </div> */}

            <div className="col-md-4 mb-3">
              <StyledLabel>Risco Máximo Aceitável:*</StyledLabel>
              <select
                className={`form-control ${
                  errors.products?.[index]?.riskLevelParameter
                    ? "is-invalid"
                    : ""
                }`}
                defaultValue={NivelRisco.MedioRisco}
                style={{ borderRadius: "15px", padding: "10px" }}
                {...register(`products.${index}.riskLevelParameter` as const, {
                  required: "Selecione o nível de risco.",
                  valueAsNumber: true, 
                })}
              >
                <option value="">Selecione...</option>
                {Object.values(NivelRisco)
                  .filter((v) => !isNaN(Number(v)))
                  .map((value) => (
                    <option key={value} value={value}>
                      {getRiscoLabel(value as NivelRisco)}
                    </option>
                  ))}
              </select>

              {errors.products?.[index]?.riskLevelParameter && (
                <div className="invalid-feedback d-block">
                  {errors.products[index]?.riskLevelParameter?.message}
                </div>
              )}
            </div>

            <div className="col-md-4 mb-3 mt-3">
              <div className="form-check mt-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`verifyAllPartners-${index}`}
                  {...register(`products.${index}.verifyAllPartners` as const)}
                />
                <label
                  className="form-check-label"
                  htmlFor={`verifyAllPartners-${index}`}
                >
                  Verificar todos os sócios
                </label>
              </div>
            </div>

            <div className="col-md-4 mb-3 mt-3">
              <div className="form-check mt-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`biometria-${index}`}
                  {...register(`products.${index}.tagBiometria` as const)}
                />
                <label
                  className="form-check-label"
                  htmlFor={`biometria-${index}`}
                >
                  Biometria
                </label>
              </div>
            </div>

            <div className="col-md-6 mb-3 d-flex align-items-end">
              <button
                type="button"
                onClick={() => remove(index)}
                className="btn btn-danger"
              >
                Remover Produto
              </button>
            </div>
          </div>
        </div>
      ))}

      <Button
        type="button"
        onClick={() =>
          append({
            idClient: 0,
            id: 0,
            description: "",
            weightLinkCPFEmail: 0,
            weightLinkCPFTelephone: 0,
            weightLinkCPFEaddress: 0,
            weightLinkEmailTelephone: 0,
            weightLinkEmailAddress: 0,
            weightLinkTelephoneAddress: 0,
            tagBiometria: false,
            verifyAllPartners: false,
            riskLevelParameter: 0,
          })
        }
      >
        Adicionar Produto
      </Button>

      <hr />
      <div className="row">
        <div className="col-md-12 mb-3 d-flex justify-content-end">
          <div className="col-md-12 mb-3 d-flex justify-content-end">
            <Button
              type="submit"
              disabled={isLoading}
              style={{
                backgroundColor: "#78E01D",
                borderColor: "#78E01D",
                fontWeight: 500,
                minWidth: "120px",
              }}
            >
              {isSaving ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Salvando...
                </>
              ) : (
                "Salvar"
              )}
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};
